import type { PropsWithChildren } from 'react';
import { ErrorHandler } from '../../errorHandler/context/ErrorContext';
import { Notifications } from '../../errorHandler/context/Notifications';
import ErrorBoundary from '../../errorHandler/ErrorBoundary';
import { ErrorViewWithLayoutView } from '../../errorHandler/ErrorView';
import { getPathKey } from '../../utils/utils';
import { Session } from '../authorization/context/Session';

type AppProps = { translationRoot: string };

const AppShell = ({ children, translationRoot }: PropsWithChildren<AppProps>) => {
  const pathKey = getPathKey(location.pathname);

  return (
    <ErrorBoundary fallback={<ErrorViewWithLayoutView />}>
      <ErrorHandler>
        <Notifications translationRoot={translationRoot} key={pathKey}>
          <Session>{children}</Session>
        </Notifications>
      </ErrorHandler>
    </ErrorBoundary>
  );
};

export default AppShell;
